import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SnackbarProvider as NotistackProvider } from 'notistack';
import { SnackbarContext, useSnackbarInternal } from './useSnackbar';
/**
 * Wrapper for the 'notistack' snackbar provider that provides some convenience
 * methods for showing snackbars.
 */ export function SnackbarProvider(props) {
    const { children, ...notistackProps } = props;
    return /*#__PURE__*/ _jsx(NotistackProvider, {
        ...notistackProps,
        children: /*#__PURE__*/ _jsx(SnackbarProviderInner, {
            children: children
        })
    });
}
// Actual provider component since we need access to the Notistack context
function SnackbarProviderInner(props) {
    const context = useSnackbarInternal();
    return /*#__PURE__*/ _jsx(SnackbarContext.Provider, {
        value: context,
        children: props.children
    });
}

//# sourceMappingURL=SnackbarProvider.js.map